import React, { useState } from "react";
import formValidation from "./FormValidation";
import saveForm from "./FormSave";
import {
  Form as BaseForm,
  TextField,
  DateField,
  CheckBoxField,
  SubmitButton,
  CancelPopupButton,
} from "../../../ui/FormElement";

export default function Form({
  closeForm,
  teamId,
  updateCollection,
  initialFormValues,
}) {
  const onSubmit = (values, { setSubmitting, resetForm, setStatus }) => {
    setSubmitting(false);
    setLoader(true);
    saveForm(values, initialFormValues, teamId, function () {
      setLoader(false);
      closeForm();
      updateCollection();
    });
  };

  let [loader, setLoader] = useState(false);

  return (
    <BaseForm
      enableReinitialize
      validationSchema={formValidation}
      initialValues={initialFormValues}
      onSubmit={onSubmit}
    >
      <TextField
        name="number"
        type="number"
        label={
          <>
            <span>Number</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <TextField
        name="gracePeriod"
        type="number"
        label={
          <>
            <span>Grace period (days)</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <DateField
        name="cycleStart"
        label={
          <>
            <span>Start Date</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <DateField
        name="cycleEnd"
        label={
          <>
            <span>End Date</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <div className="checkbox">
        <CheckBoxField name="current" label=" Current" />
      </div>

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          title="Cancel"
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          onClick={closeForm}
        />
        <SubmitButton
          title={loader ? "Please, wait ..." : "Save"}
          className="btn width-120 btn-primary submit-button mr5 ml5"
        />
      </div>
    </BaseForm>
  );
}
